import { render, staticRenderFns } from "./ParentDeclarationForm.vue?vue&type=template&id=5c61cfec&scoped=true"
import script from "./ParentDeclarationForm.vue?vue&type=script&lang=js"
export * from "./ParentDeclarationForm.vue?vue&type=script&lang=js"
import style0 from "./ParentDeclarationForm.vue?vue&type=style&index=0&id=5c61cfec&prod&scoped=true&lang=css"
import style1 from "./ParentDeclarationForm.vue?vue&type=style&index=1&id=5c61cfec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c61cfec",
  null
  
)

export default component.exports